import { type RouteRecordRaw } from "vue-router";

// The Payment Contact Info form previously lived at /payments/payment-settings.
// It now lives on the Settings page (see organizationSettings module), so this
// module no longer registers a route. The api helpers here are still used by
// the network admin ComprehensivePaymentSettings view.
export const routes: RouteRecordRaw[] = [];
